// Huella real de la firma respecto a la posición (x, y) guardada en signature_positions /
// owner_signature_positions, en unidades PDF (origen arriba-izquierda), para las posiciones que se
// colocan con el selector (documento que YA tiene líneas de firma y firma avanzada con templateId -3).
//
// Es la ÚNICA definición: el cuadro guía del dueño, el cuadro guardado, el recuadro del invitado y el
// estampado deben usarla para que lo que se ve sea exactamente donde queda la firma.
//
// NO cambiar estos valores sin migrar posiciones: los documentos ya enviados guardaron (x, y) con este
// significado, y la documentación de la API pública publica las fórmulas que dependen de ellos.
//  - SIMPLE_EXISTING_LINES: lo estampa el navegador (helpers/index.js -> savePdfSigns).
//  - ADVANCED_TEMPLATE: lo estampa Seguridata con la plantilla del backend
//    (storj_storage/src/controllers/seguridataController.js -> buildSeguridataTemplate: x + 20, y + 40, 180 x 80).
import { typesSign } from './typesSign';

export const SIGNATURE_GEOMETRY = {
  SIMPLE_EXISTING_LINES: { offsetX: 10, offsetY: 55.5, width: 190, height: 60 },
  ADVANCED_TEMPLATE: { offsetX: 20, offsetY: 40, width: 180, height: 80 }
};

export const getSignatureGeometry = (typeOfSign) =>
  typeOfSign === typesSign.FEA || typeOfSign === typesSign.FAB
    ? SIGNATURE_GEOMETRY.ADVANCED_TEMPLATE
    : SIGNATURE_GEOMETRY.SIMPLE_EXISTING_LINES;

// Rectángulo de la firma en unidades PDF a partir de la posición guardada.
export const getSignatureFootprint = (pos, geometry) => ({
  left: Number(pos.x) + geometry.offsetX,
  top: Number(pos.y) + geometry.offsetY,
  width: geometry.width,
  height: geometry.height
});

// Posición a guardar para que la firma ocupe un rectángulo con esquina superior izquierda en
// (left, top), ajustada para que la firma completa quede dentro de la página.
export const getPositionFromFootprintOrigin = (left, top, geometry, pageWidth, pageHeight) => {
  const maxLeft = Math.max(geometry.offsetX, pageWidth - geometry.width);
  const maxTop = Math.max(geometry.offsetY, pageHeight - geometry.height);
  const clampedLeft = Math.min(Math.max(left, geometry.offsetX), maxLeft);
  const clampedTop = Math.min(Math.max(top, geometry.offsetY), maxTop);
  return {
    x: Math.round(clampedLeft - geometry.offsetX),
    y: Math.round(clampedTop - geometry.offsetY)
  };
};
